var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"payment d-flex align-center justify-center"},[_c('div',[_c('Loader'),_c('h3',[_vm._v(_vm._s(_vm.$t('text.loading')))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }